<template>
  <div
    class="flex w-full flex-col space-y-4 rounded-lg border-2 border-ontick-steel-300 bg-gray-50 px-6 py-6 dark:border-ontick-graphite-500 dark:bg-ontick-graphite-500 sm:flex-row sm:space-y-0"
  >
    <!-- <svg
          class="mr-6"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="40" height="40" rx="20" fill="#6C737F" />
          <path
            d="M10 25H30V27H10V25ZM11.15 20.95L12 19.47L12.85 20.95L14.15 20.2L13.3 18.72H15V17.22H13.3L14.15 15.75L12.85 15L12 16.47L11.15 15L9.85 15.75L10.7 17.22H9V18.72H10.7L9.85 20.2L11.15 20.95ZM17.85 20.2L19.15 20.95L20 19.47L20.85 20.95L22.15 20.2L21.3 18.72H23V17.22H21.3L22.15 15.75L20.85 15L20 16.47L19.15 15L17.85 15.75L18.7 17.22H17V18.72H18.7L17.85 20.2ZM31 17.22H29.3L30.15 15.75L28.85 15L28 16.47L27.15 15L25.85 15.75L26.7 17.22H25V18.72H26.7L25.85 20.2L27.15 20.95L28 19.47L28.85 20.95L30.15 20.2L29.3 18.72H31V17.22Z"
            fill="#171E27"
          />
        </svg> -->
    <i v-html="icon"></i>
    <div class="space-y-4">
      <div class="sm:space-y-3">
        <h1
          class="text-lg font-semibold text-ontick-carbon-900 dark:text-gray-200 sm:text-2xl"
        >
          <!-- Minha senha -->
          {{ title }}
        </h1>

        <p
          class="text-sm text-ontick-steel-700 dark:text-gray-400 sm:text-base"
        >
          <!-- Clique no botão abaixo para resetar sua senha na plataforma -->
          {{ description }}
        </p>
      </div>
      <div
        is="transition"
        v-on:enter="enter"
        v-on:leave="leave"
        v-bind:css="false"
        appear
        mode="out-in"
      >
        <ontick-button :key="1" v-if="!count" @click.native="$emit('action')">
          <!-- Redefinir senha -->
          {{ actionText }}
        </ontick-button>
        <div :key="2" v-else class="flex justify-center">
          <timer-component />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timerComponent from "../../../shared/components/contador/timer.component.vue";
export default {
  components: { timerComponent },
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    actionText: {
      type: String,
    },
    count: {
      type: Boolean,
    },
  },
  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>

<style></style>
